// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3V7YH","col":"Table_col__3j5HT","fulfillmentStatus":"Table_fulfillmentStatus__20AGN","emailCol":"Table_emailCol__2tfLT"};